import React from 'react';

import TagDropdown from '../../../tag-dropdown';
import { ResponsiveTagList } from '../../../responsive-tag-list';

import style from './customer-tags.module.less';
import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

type Tag = {
  tagId: string;
  name: string;
  hexColor: string;
};

type CustomerTagsProps = {
  tags: Tag[];
  selectedTags: Tag[];
  onTagToggled: (tag: Tag) => void;
};

export const CustomerTags = ({ tags, selectedTags, onTagToggled }: CustomerTagsProps) => {
  return (
    <div className={style['customer-tags']}>
      <TagDropdown
        dropdownMenuTogglerClass={buttonTextStyle['button-text']}
        onTagToggled={onTagToggled}
        selectedTags={selectedTags}
        tags={tags}
        theme='link'
      />
      <ResponsiveTagList tags={selectedTags} />
    </div>
  );
};
